import { ActivityDetail } from './activityDetail';
import { Entity } from './entity';

export class Activity extends Entity {
    public id: number;
    public key: string;
    public name: string;
    public activityDetails: ActivityDetail[];
  }  